<template>
	<div class="flexcenter" style="">

		<div class="flexcenter" style="flex-grow:1;flex-direction: row;align-items: center;">

			<Circle v-if="this.isProductType('M')" fileName="w3_mc_white" color="--bg-message" hover="--bg-message-dark"
				style="margin-right:3px;" :title="this.userModel?.company?.resellerType" />
			<Circle v-else-if="this.isProductType('C')" fileName="w3_cykel_white" color="--bg-message"
				hover="--bg-message-dark" style="margin-right:3px;" :title="this.userModel?.company?.resellerType" />
			<Circle v-else-if="this.isProductType('B')" fileName="w3_bil_white" color="--bg-message" hover="--bg-message-dark"
				style="margin-right:3px;" :title="this.userModel?.company?.resellerType" />



			<div class="flexcenter" style="flex-direction: column;align-items: start;">
				<div id="name" class="flexcenter">{{ this.companyName
					}}

				</div>

				<div id="menu" class="flexcenter" style="">
					<div class="menu-item link"
						@click="this.$emit('hideAllSubmenu'); this.$router.push('/user/reseller-information');">
						Era uppgifter</div>
					<div class="menu-item link" @click="this.$emit('hideAllSubmenu'); this.$router.push('/user/reseller-news');">
						Erbjudanden</div>



					<div>

						<div class="menu-item flexcenter link" @click=" this.showOrderMenu = !this.showOrderMenu">
							Order
							<Icon :fileName="this.showOrderMenu ? 'w3_chevron_up_dark' : 'w3_chevron_down_dark'"
								style="width:12px;height:12px;margin-left:2px" />
							<!-- order menu -->

						</div>

						<div v-if="this.showOrderMenu"
							style="position:absolute;margin-top:0px;width:300px;height:auto;background-color:var(--grey-1);padding:10px;border-radius:0px 0px 0px 0px;"
							class="drop-shadow" @mouseleave="this.showOrderMenu = false;">
							<div class="order-item link flexcenter" @click="this.createOrder({ dropship: false })">
								<Circle fileName="w3_add_white" padding="20%" size="25px" style="margin-right:5px;" color="--grey-5"
									hover="" /> Skapa ny order
							</div>
							<div v-if="!this" class="order-item link flexcenter" @click="this.createOrder({ dropship: true })">
								<Circle fileName="w3_user_white" padding="20%" size="25px" style="margin-right:5px;" color="--grey-5"
									hover="" />Skapa ny dropship
							</div>
							<div class="order-item link flexcenter" style="justify-content: space-between;"
								@click.stop="this.showCurrentOrder()">Visa aktuell order
								<div style="background:var(--grey-5);padding:3px;border-radius: 5px;">{{ this.currentOrder?.orderId
									}}
								</div>
							</div>
							<div class="order-item link flexcenter" style="justify-content: space-between;"
								@click.stop="this.$router.push('/user/order-list'); this.$emit('hideAllSubmenu'); this.showOrderMenu = false;">
								Visa alla ordrar
								<div style="background:var(--grey-5);padding:3px;border-radius: 5px;">{{ this.orderListLength }}
								</div>
							</div>




							<hr />
							<div id="orderListPreliminary"
								style="background:transparent;overflow:scroll;min-height:200px;max-height:50vh;">

								<div v-for="order in this.getOrderListPreliminary" :key="order.orderId"
									style="padding:10px;margin-bottom:5px;border-radius:3px;"
									:class="this.currentOrderId == order.orderId ? 'selected' : 'unselected'">

									<div class="flexcenter link" @click="this.orderSelected(order.orderId)">


										<div style="flex-grow:1;">
											<div class="flexcenter">
												<b>{{ order.orderId }}</b>
												<Circle v-if="order?.customerId || order?.meta?.dropship" fileName="w3_user_white"
													color="--grey-6" hover="" padding="20%" size="15px" style="margin-left:5px;" />
												<span v-if="order.localId">, {{ order.localId }}</span>
											</div>

											<b style="font-size:80%;color:grey;">{{ this.timeSince(order?.orderStatusDate) }}</b>
										</div>

										<Icon fileName="w3_chevron_right_dark" size="20px" style="width:10px;height:15px;" />

									</div>

								</div>
							</div>
						</div>

					</div>

					<div class="menu-item link flexcenter" @click="this.displayPriceClicked()">Priser <div
							v-if="this.displayPrice"
							style="background: var(--bg-message);color:white;padding:2px;border-radius: 3px;font-size:70%;margin-left:3px;">
							ÅF</div>
					</div>

				</div>
			</div>

		</div>



		<!-- current order badge -->
		<div id="currentOrderBadge" v-if="this.currentOrderId" :title="this.currentOrderTitle" class="flexcenter" style="">

			<div class="menu-item link flexcenter" @click.stop="this.showCurrentOrderFromBadge()">

				<Icon fileName="w3_cart_dark" style="width:15px;height:15px;margin-left:5px;margin-right:5px;" />
				<b style="display:block;overflow:hidden;height:20px;">
					{{ this.currentOrderId }} - {{ this.currentOrderLocalId }}
				</b>


				<div v-if="this.currentOrder"
					style="background:var(--grey-5 );padding:1px;font-size:90%;padding-left:5px;padding-right:5px;border-radius: 3px;">
					{{ this.currentOrder?.orderRowList?.length }}</div>
				<Icon :fileName="this.isOrderMenuVisible ? 'w3_chevron_up_dark' : 'w3_chevron_down_dark'"
					style="width:15px;height:15px;margin-left:5px;" title="Logga ut" />




			</div>




		</div>

		<!-- orderRow dropdown-->
		<div>
			&nbsp;
			<OrderRowMessage :key="Math.random() * 1000" />
		</div>
	</div>

</template>


<script>
import { USER_STORE_COMMIT, USER_STORE_GETTER } from '../store/user-store';
import { userMixin } from "@/mixins/userMixin.js";
import { formatMixin } from "@/mixins/formatMixin.js";
import OrderRowMessage from './OrderRowMessage.vue';

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";

export default {
	name: "ResellerMenu",
	components: { OrderRowMessage  },
	mixins: [userMixin, formatMixin],
	props: {
		isOrderMenuVisible: Boolean
	},
	data() {
		return {
			showOrderMenu: false
		};
	},
	computed: {

		currentOrderTitle(){
			var currentOrder = this.currentOrder

			if (!currentOrder){
				return "Order saknas";
			}

			var title = "OrderId: " + currentOrder.orderId + "\n";
			title = title + "Märkning: " + currentOrder.localId + "\n"
			title = title + "Namn: " + currentOrder.contactPerson + "\n"
			title = title + "Skapad: " + currentOrder.orderStatusDate + "\n"
			return title;
		},

		currentOrderLocalId(){
			const localId = this.currentOrder?.localId
			
			if (localId && localId.length > 10){
				return localId.substring(0, 5);
			}

			return localId;
		},

		companyName(){
			
			return this.userModel?.company?.name
		},

		//baseModel() {
		//	return this.$store.getters[STORE_GETTER.BASE_MODEL]
		//},

		getOrderListPreliminary(){
			var orderList = this.$store.getters[USER_STORE_GETTER.GET_ORDER_LIST]; 
			orderList = orderList?.filter(order => order !== null && order?.orderStatus?.status == this.orderStatusPreliminary.status && order.canBeEdited);
			orderList = orderList.sort((a, b) => b.orderStatusDate?.localeCompare(a.orderStatusDate))

			return orderList;

			//return orderList?.find(order => order !== null);
		},

		displayPrice(){
			return this.$store.getters[USER_STORE_GETTER.DISPLAY_PRICE1];
		}



	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {

		isProductType(type){
			return this.userModel?.company?.resellerType?.toUpperCase()?.includes(type);
		},
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });
		orderSelected(orderId) {
			const orderList = this.$store.getters[USER_STORE_GETTER.GET_ORDER_LIST_INDEXED]; 
			const order = orderList[orderId];
			order.meta.expanded = true;
			this.$store.commit(USER_STORE_COMMIT.SET_CURRENT_ORDER_ID, orderId)
			this.$emit('showCurrentOrder');
		},
		showCurrentOrderFromBadge(){
			/*const currentOrderId = this.currentOrderId
			const orderList = this.$store.getters[USER_STORE_GETTER.GET_ORDER_LIST_INDEXED];
			const order = orderList[currentOrderId];*/
			const currentOrder = this.currentOrder;

			if (currentOrder){
				currentOrder.meta.expanded = true;
			}

			
			this.$emit('toggleSubMenu', 'order');
			this.showOrderMenu = false
		},

		showCurrentOrder(){

			const currentOrder = this.currentOrder;

			if (currentOrder) {
				currentOrder.meta.expanded = true;
			}
			
			this.$emit('showCurrentOrder');

			setTimeout(() => { // FP: blir något problem med animeringen som visar menyn annars. 
				this.showOrderMenu = false
			}, 500);
			
		},

		displayPriceClicked(){
			const displayPrice = this.displayPrice;
			
			this.$store.commit(USER_STORE_COMMIT.SET_DISPLAY_PRICE1, !displayPrice);
		}
		/*showCurrentOrder(){
			
			const currentOrder = this.currentOrder;

			if (currentOrder?.meta){
				currentOrder.meta.expand = true
			}
			


			this.$emit('showCurrentOrder'); 
			this.showOrderMenu = false;
		}*/

	},
	created() {

	}
};
</script>

<style scoped>

 div#menu div.menu-item{

	/*background:var(--grey-2); 
	padding:5px;
	border-radius: 5px;*/
	color:black;
	font-weight:bold;
	font-size: 90%;

}

div#menu{
	gap:20px;
}

div div#name{
	color:grey;
	font-weight:bold;
	font-size:100%;
}

div div.order-item{
	background:var(--grey-3);
	padding:10px;
	margin-bottom:5px;
	border-radius: 5px;
}

div div.order-item:hover {
	background: var(--grey-4);
}

div#orderListPreliminary div.selected{
	background:var(--grey-4); 
}

div#orderListPreliminary div.unselected {
	background: var(--grey-2);
}

div#orderListPreliminary div.unselected:hover {
	background: var(--grey-4);
}


div#orderListPreliminary div.selected:hover {
	background: var(--grey-5);
}

div#currentOrderBadge{
		background: var(--grey-4);
			border-radius: 5px;
			padding: 5px;
}

div#currentOrderBadge b{
	
		transition: max-width 0.2s ease-in-out;
		max-width: 0px;
}
div#currentOrderBadge:hover b{
		transition: max-width 0.2s ease-in-out;
		max-width: 200px;
}



</style>